// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#upAccount .upAccount-form .el-form-item--small.el-form-item {\n  margin: 0 auto 18px auto;\n}\n#upAccount .upAccount-form .el-textarea {\n  width: 440px;\n}\n#upAccount .upAccount-form .form-btn {\n  display: block;\n  margin-left: 0;\n  margin-top: 40px !important;\n  text-align: center;\n}\n#upAccount .upAccount-form .tip-style {\n  font-size: 14px;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #653EB3;\n  line-height: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
